"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.cusper = void 0;
const cusper_1 = require("@metaplex-foundation/cusper");
const generated_1 = require("./generated");
exports.cusper = (0, cusper_1.initCusper)(generated_1.errorFromCode);
//# sourceMappingURL=errors.js.map